module.exports = __webpack_public_path__ + "static/media/h1_intro_bw.80baebf9.webp";